import * as Dialog from '@radix-ui/react-dialog';

import { TriggerOrders } from '@/components/TriggerOrders/TriggerOrders';

import { Modal } from '@/ui/Modal';

import type { TriggerOrderTarget } from './types';
import { formatTokenBalance } from './utils';

type PortfolioTriggerOrdersModalProps = {
  onClose: () => void;
  target: TriggerOrderTarget | null;
};

export function PortfolioTriggerOrdersModal({ onClose, target }: PortfolioTriggerOrdersModalProps) {
  if (!target) return null;

  const { referencePriceUsd, token } = target;
  const displaySellAmount = formatTokenBalance(parseFloat(token.balanceFormatted));

  return (
    <Modal isOpen onClose={onClose}>
      <Dialog.Title className="sr-only">Add Take Profit and Stop Loss orders</Dialog.Title>
      <div className="flex flex-col">
        <TriggerOrders
          chainId={token.chainId}
          displaySellAmount={displaySellAmount}
          onCancel={onClose}
          referencePriceUsd={referencePriceUsd}
          sellAmount={token.balanceFormatted}
          sellTokenAddress={token.tokenAddress}
          uiLocation="portfolio"
        />
      </div>
    </Modal>
  );
}
